import { DataBean } from "../DataBean";

export class AirLine extends DataBean {



    public async deleteAirLine(idAirLine: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteAirLine_Number", [idAirLine]);
    }

    public async getAirLineCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getAirLineCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

}